const formatNumber = (number: any) => {
  return number === null || number === undefined
    ? ''
    : Math.round(parseFloat(number)).toLocaleString();
};

export { formatNumber };
